import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, LangType } from "./hooks/useTranslation";

export interface Album {
  id: string;
  EN: { title: string; description?: string };
  UA: { title: string; description?: string };
  path: string;
}

export const allAlbums: Album[] = [
  {
    id: "color-wheel",
    EN: {
      title: "Color Wheel",
      description: "A vibrant collection of colorful artwork",
    },
    UA: {
      title: "Кольорове колесо",
      description: "Яскрава колекція кольорових робіт",
    },
    path: "/exhibition/color-wheel",
  },
  {
    id: "portraits-black-and-white",
    EN: {
      title: "Portraits Black and White",
      description: "Elegant monochrome portrait collection",
    },
    UA: {
      title: "Чорно-білі портрети",
      description: "Елегантна колекція монохромних портретів",
    },
    path: "/exhibition/portraits-black-and-white",
  },
  {
    id: "portraits-color",
    EN: {
      title: "Portraits in Color",
      description: "A lively collection of colorful portraits",
    },
    UA: {
      title: "Портрети в кольорі",
      description: "Живописна колекція кольорових портретів",
    },
    path: "/exhibition/portraits-color",
  },
];

interface ExhibitionProps {
  lang: LangType;
}

export const Exhibition: React.FC<ExhibitionProps> = ({ lang }) => {
  const t = useTranslation(lang);

  return (
    <main className="page-container">
      <section className="stories">
        <h3>{t("exhibitionTitle")}</h3>
        {allAlbums.map((album) => (
          <Link key={album.id} to={album.path}>
            {album[lang].title}
          </Link>
        ))}
      </section>
    </main>
  );
};
